
import React from "react"
import { Col, DropdownItem, DropdownMenu, DropdownToggle, Row, Table, UncontrolledDropdown } from "reactstrap"
import { truncate } from "../../helpers/helpers";

export const PostsList = (props) => {

    const { posts, republish, editPost, togglePost } = props;

    const renderPostRow = () => {
        if (posts) {
            return posts.map((p, i) => (
                <tr key={i}>
                    <td>
                        <p className="text-muted mb-0">
                            {p.user && p.user[0] ? p.user[0].firstName + ' ' + p.user[0].lastName : ''}
                        </p>
                    </td>
                    <td>
                        <p className="text-muted mb-0">
                            {p.community && p.community[0] ? p.community[0].name : ""}
                        </p>
                    </td>
                    <td>
                        <p className="text-muted mb-0">
                            {truncate(p.post, 20, '...')}
                        </p>
                    </td>
                    <td>
                        <p className="text-muted mb-0">
                            {p.created}
                        </p>
                    </td>
                    <td>
                        <p className="text-muted mb-0">
                            {p.modified}
                        </p>
                    </td>
                    <td>
                        <p className="text-muted mb-0">
                            {p.status}
                        </p>
                    </td>
                    <td>
                        <UncontrolledDropdown>
                            <DropdownToggle
                                href="#"
                                className="card-drop"
                                tag="i"
                            >
                                <i className="mdi mdi-dots-horizontal font-size-18"></i>
                            </DropdownToggle>
                            <DropdownMenu right>
                                {republish ? <DropdownItem onClick={() => { if (republish) republish(p) }}>Repost</DropdownItem> : null}
                                {editPost ? <DropdownItem onClick={() => { if (editPost) editPost(p) }}>Edit</DropdownItem> : null}
                                {togglePost ? <DropdownItem onClick={() => { if (togglePost) togglePost(p) }} >{p.status === "draft" ? 'Publish' : 'Unpublish'}</DropdownItem> : null}
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </td>
                </tr>
            ))
        }
        return null;
    }

    const renderPosts = () => {
        return (
            <React.Fragment>
                <Row>
                    <h5>Published Related</h5>
                </Row>
                <Row className="mx-0 px-0">
                    <Col lg="12">
                        <div className="">
                            <div className="table-responsive">
                                <Table className="project-list-table table-nowrap align-middle table-borderless">
                                    <thead>
                                        <tr>
                                            <th scope="col">Post Author</th>
                                            <th scope="col">Post Community</th>
                                            <th scope="col">Post</th>
                                            <th scope="col">Date Published</th>
                                            <th scope="col">Modified</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {renderPostRow()}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }

    return renderPosts()
}